import { _ as o } from "./_root.js";
var r = o, n = function() {
  return r.Date.now();
}, a = n;
export {
  a as n
};
//# sourceMappingURL=now.js.map
